import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class MemberFee {
    public member_feeID: string = '';
    public member_typeID: string = '';
    public type: number = 0;
    public label: string = '';
    public description: string = '';
    public amount: number = 0;
    public invoice_noteIDs: string[] = [];
    public creatorID: string = '';
    public updaterID: string = '';
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;

    constructor(
        member_feeID: string,
        member_typeID: string,
        type: string,
        label: string,
        description: string,
        amount: string,
        invoice_noteIDs: string,
        creatorID: string,
        updaterID: string,
        datetime_created: string,
        datetime_updated: string
    ) {
        this.member_feeID = this[CheckNotNull](member_feeID) ? member_feeID : '';
        this.member_typeID = this[CheckNotNull](member_typeID) ? member_typeID : '';
        this.type = this[CheckNotNull](type) ? parseInt(type) : 0;
        this.label = this[CheckNotNull](label) ? label : '';
        this.description = this[CheckNotNull](description) ? description : '';
        this.amount = this[CheckNotNull](amount) ? parseInt(amount) : 0;
        this.invoice_noteIDs = this[CheckNotNull](invoice_noteIDs) ? invoice_noteIDs.split(',') : [];
        this.creatorID = this[CheckNotNull](creatorID) ? creatorID : '';
        this.updaterID = this[CheckNotNull](updaterID) ? updaterID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MemberFee